export const capitalize = (inputString = '') =>
  inputString
    .split('')
    .map((char, index) => {
      return index > 0 ? char.toLowerCase() : char.toUpperCase();
    })
    .join('');
